<template>
  <button-component
      v-if="isLogged"
      variant="icon"
      @btn-click="toggleFavorite"
      :disabled="disabled"
      class="btn"
  >
    <star-icon
        :class="{
        empty: !isFavorite,
      }"
    />
  </button-component>
</template>

<script>
import StarIcon from '../../assets/img/starIcon';
import {FAVORITE_TYPES, FAVORITE_SUBJECT} from '@/const';
import {mapActions, mapGetters, mapState} from 'vuex';
import {
  ADD_FAVORITE,
  ADD_POPUP,
  DELETE_FAVORITE,
  GET_FAVORITE,
} from '@/store/actionTypes';
import ButtonComponent from '../base-components/buttons/ButtonComponent';
import VisaicV3Analytics from '@/components/base-components/Analytics/VisaicV3Analytics';

export default {
  name: 'FavoriteStarToggle',
  components: {
    ButtonComponent,
    StarIcon,
  },
  props: {
    favorite: {
      type: Object,
      required: true,
      validator(item) {
        return item.hasOwnProperty('id') && item.hasOwnProperty('name');
      },
    },
    type: {
      type: String,
      required: true,
      validator(favType) {
        return Object.values(FAVORITE_TYPES).includes(favType);
      },
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  methods: {
    ...mapActions({
      addFavorite: ADD_FAVORITE,
      deleteFavorite: DELETE_FAVORITE,
      getFavorite: GET_FAVORITE,
      addPopup: ADD_POPUP,
    }),
    add() {
      this.trackAnalytics('add');
      return this.addFavorite({
        id: String(this.favorite.id),
        type: this.type,
      });
    },
    async remove() {
      const res = this.addPopup({
        component: './DeleteFavoritePopup.vue',
        favorite: this.favorite,
        imagePath: this.imagePath,
      });
      res.then(() => {
        this.trackAnalytics('remove');
        return this.deleteFavorite({
          id: this.isFavorite.id,
        });
      }).catch((reason) => {
        console.log('reason', reason);
      });
    },
    toggleFavorite() {
      this.disabled = true;
      let request;
      if (this.isFavorite) {
        request = this.remove();
      } else {
        request = this.add();
      }
      request.finally(() => (this.disabled = false));
    },
    trackAnalytics(action = 'add') {
      VisaicV3Analytics.event({
        event: 'favorite',
        action: action,
        type: this.type,
        favorite_id: this.favorite.id,
        favorite_name: this.favorite.name,
        favorite_subject: FAVORITE_SUBJECT[this.type] || '',
      });
    },
  },
  computed: {
    ...mapState({
      favorites: ({favorite}) => favorite.favorites,
    }),
    ...mapGetters({
      isLogged: 'isLogged',
    }),
    isFavorite() {
      return this.favorites?.find(
          ({
            favoritable_type: type,
            favoritable_id: id,
          }) => {
            return id === this.favorite.id && type === this.type;
          },
      );
    },
    imagePath() {
      const imgAliases = ['images', 'image', 'img'];
      return this.favorite[imgAliases.find((key) => this.favorite.hasOwnProperty(key))];
    },
  },
  mounted() {
    this.getFavorite().catch(() => {});
  },
};
</script>

<style scoped lang="scss">
.btn {
  padding: 0.25rem;

  &:disabled {
    background: transparent;

    svg {
      filter: opacity(0.5);
    }
  }

  svg {
    fill: var(--theme-accent);
    stroke: var(--theme-accent);
    width: 1.25rem;
    height: 1.25rem;

    &.empty {
      stroke: var(--theme-accent);
      fill: transparent;
    }
  }
}
.teams-star svg {
  width: 1.25rem;
  height: 1.25rem;
}
</style>
